module.exports = __webpack_public_path__ + "static/sc-01-a6bc8e53bff940a9e84a8c969cd23b23.png";